import { Component, Input, ViewChild, } from '@angular/core';

import { DateRangePickerComponent } from 'rev-shared/ui/datePicker/DateRangePicker.Component';
import { IDateRange } from 'rev-shared/ui/datePicker/DateRangePicker.Component';
import { escape } from 'rev-shared/util';
import { firstValueFrom } from 'rev-shared/rxjs/firstValueFrom';

import { AnalyticsService } from './Analytics.Service';

import styles from './ReportTabContent.Component.module.less';

@Component({
	selector: 'report-tab-content',
	templateUrl: './ReportTabContent.Component.html'
})
export class ReportTabContentComponent {
	@Input() public header: string;
	@Input() public headerTag: string;
	@Input() public showDateFilter: boolean;

	public readonly styles = styles;
	public readonly escape = escape;

	public dateRange: IDateRange;

	@ViewChild(DateRangePickerComponent)
	public dateRangePicker: DateRangePickerComponent;

	constructor(
		private AnalyticsService: AnalyticsService
	) {}

	public onDateRangeChanged(dateRange: IDateRange): void {
		this.setDateFilter(dateRange);
	}

	public ngAfterViewInit(): void {
		if (this.dateRangePicker) {
			firstValueFrom(this.AnalyticsService.dateFilter$)
				.then(dateFilter => {
					this.dateRange = dateFilter || this.dateRangePicker.getDaysRange(30);
					if (!dateFilter) {
						this.setDateFilter(this.dateRange);
					}
				});
		}
	}

	private setDateFilter(dateFilter: IDateRange): void {
		window.setTimeout(() => {
			this.AnalyticsService.setDateFilter({
				label: this.dateRangePicker.getLabel(),
				range: dateFilter.range
			});
		}, 0);
	}
}
